import React, { useState } from "react";

import { useActiveLanguage } from "shared/hooks/useActiveLanguage";
import { useMenuSettings } from "shared/hooks/useMenuSettings";
import { setLocalizedValue, trimLocalizedMap } from "shared/lib/localizedMap";
import {
    Button,
    LabeledField,
    LanguageSegmentedControl,
    Modal,
    Stack,
    TextInput,
} from "shared/ui";

import { useMenuEditorContext } from "features/MenuEditor/context";

import { LanguageRow } from "./styles";

// Создание спрашивает только название: расписание, время приготовления и стоп-лист
// правятся в «Настройках категории» — иначе первая же форма выглядит как анкета.
export const CreateCategoryDialog = () => {
    const state = useMenuEditorContext();

    const [name, setName] = useState<Record<string, string>>({});

    // Языки меню нужны только этой форме — грузим их вместе с ней, а не на весь экран.
    const { settings } = useMenuSettings(state.menuId);
    const languages = settings?.availableLanguages.enabledLocales || [];
    const { activeLang, setActiveLang } = useActiveLanguage(state.locale, languages);

    const submit = async () => {
        const created = await state.mutations.createCategory(trimLocalizedMap(name));
        if (created) state.closeDialog();
    };

    const canSubmit =
        Object.values(name).some((value) => value.trim().length > 0) &&
        !state.mutations.saving;

    return (
        <Modal
            open
            onClose={state.closeDialog}
            title="Новая категория"
            maxWidth="xs"
            actions={
                <>
                    <Button
                        variant="outlined"
                        color="neutral"
                        disabled={state.mutations.saving}
                        onClick={state.closeDialog}
                    >
                        Отмена
                    </Button>
                    <Button variant="contained" disabled={!canSubmit} onClick={submit}>
                        Создать
                    </Button>
                </>
            }
        >
            <Stack $gap={10}>
                {languages.length > 1 && (
                    <LanguageRow>
                        <LanguageSegmentedControl
                            languages={languages}
                            activeLang={activeLang}
                            primaryLang={state.locale}
                            onChange={setActiveLang}
                            isMissing={(lang) => !name[lang]}
                        />
                    </LanguageRow>
                )}

                <LabeledField label="Название" hint="Раздел меню: завтраки, супы, напитки">
                    <TextInput
                        value={name[activeLang]}
                        placeholder="Например, Завтраки"
                        onChange={(value) =>
                            setName(setLocalizedValue(name, activeLang, value))
                        }
                    />
                </LabeledField>
            </Stack>
        </Modal>
    );
};
